// extracted by css-extract-rspack-plugin
export default {"root":"tKU6kH_wc9E1kTBO"};